import { myBindStudents } from '@/api/mine'

export default {
    namespaced:true,
    state: {//state
        students: [],
        currentStudent: JSON.parse( localStorage.getItem('currentStudent') || '{}' )
    },
    mutations: {
        updateBindStudents(state,students) {
            state.students = students
        },
        setCurrentStudent(state,student){
            state.currentStudent = student
            localStorage.setItem('currentStudent',JSON.stringify(student))
        },
        setGuardians(state, guardians){
            state.guardians = guardians
        }

    },
    actions: {
        async getBindStudents({commit,state}) {
            const { success, data }  = await myBindStudents()
            if (success) {
                commit('updateBindStudents', data)
                if( data.length > 0){
                    if(!state.currentStudent.studentId || data.filter(item => item.studentId == state.currentStudent.studentId ).length == 0){
                        commit('setCurrentStudent',data[0])
                    }
                }
            }
            return data
        },
        setCurrentStudent({ commit }, student) {
            commit('setCurrentStudent', student)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/store/bindStudents.js